/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AccessibilityIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACIklEQVR4nMVVzWoUQRAeD+IfiMnNGMWbD+BFBAkIgYGZrqo+zFbtbnATD/sIIhHBtxDx5w1McgjxInhWUY+JCB7Uu27iUaNUz8jOT8/04kEbCpqemqrq7/uqOor+58qybB5IbgLKliHZA+LvasV+E6C3liSDub8JfAKI7wDxBEh+dZlB+WaQ1/WfmYIDyAKgvAoFhnoi4ndpml3oDG7tcBFIvvgr5e0kyc45H5SdFp/P6tMOC8qbtgqtHS7+8UXk8x03eb00Gh1vQuMwb4fAzpggN75dr34+SCjKjgZ2wZGfhYivqMtJse5oJdFghqQPJA9UmgblhzMnU3fWt3Z4lmhw2cPH6jQBylbDwcr1Oozj8fioWv3c2N4VDxcbUweU935YeNcg3wcQaHAGAu4b8q6fbNmbJiDZD+j8sCkKOezuC9kv3+Ag1EhRM0Gg+XgShog8zjPeugKRG1zdFT1SvzgenlYrEjwJyPppibDeWpczIl/Lb8qPDfFD3afUXwrcYFRpNG2OFucPURQdWV5eOZXDwpM0TU/qGZB89Afnr4ijM1VMkdf9Xcl3i++rpepWirN7LZ18q85ZpANKB5UHnosF5i9K589zaLNLnoJeeoedLh21OnJrCa6qlXVvkH8i9g1A70YN90/6nniDTwmXBa0irHOp4/42+OCU4dKR20F8hVDFPI7jYzMFr0I2mMvJ5c18LsmB63rdE2+oFBtq+dfrN59mmvXMo9mMAAAAAElFTkSuQmCC)
 */
export const AccessibilityIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm-2.06-3.65a1 1 0 0 1-1.88-.7l1.9-5.08a.5.5 0 0 0 .04-.18v-2.22a.5.5 0 0 0-.38-.48l-2.86-.72a1 1 0 0 1 .48-1.94l3.55.89a5 5 0 0 0 2.42 0l3.55-.89a1 1 0 1 1 .48 1.94l-2.86.72a.5.5 0 0 0-.38.48v2.22l.03.18 1.9 5.08a1 1 0 0 1-1.87.7l-1.6-4.25a.5.5 0 0 0-.93 0l-1.6 4.25ZM14 6a2 2 0 0 0-2-2 2 2 0 0 0-2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
